"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = exports.SubtitleContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.SubtitleContainer = styled_components_1.default.div `
  ${style_1.default.Text.Definition.Subtitle};
  color: ${props => props.theme.Color.Text.Secondary};
`;
const Subtitle = ({ children }) => {
    return ((0, jsx_runtime_1.jsx)(exports.SubtitleContainer, { children: children }));
};
exports.Subtitle = Subtitle;
